import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  line-height: 1.5;\n  padding: 4px 8px;\n  border-radius: 3px;\n  height: 32px;\n  display: inline-block;\n  font-weight: 600;\n  &.type10 {\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n  //교사용\n  &.type20 {\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n  //해설지\n  &.type30 {\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n  //부가자료\n  &.type40 {\n    color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n  @media (max-width: 768px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import React from "react";
export const ExtraResourcesWrapper = styled.span.withConfig({
    componentId: "sc-64990a3c-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_yellow_400, (props)=>props.theme.new.colors.sol_yellow_100, (props)=>props.theme.new.colors.sol_mint_400, (props)=>props.theme.new.colors.sol_mint_100, (props)=>props.theme.new.colors.sol_blue_400, (props)=>props.theme.new.colors.sol_blue_100, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_gray_100);
var ExtraResourcesType;
(function(ExtraResourcesType) {
    ExtraResourcesType[ExtraResourcesType["Student"] = 10] = "Student";
    ExtraResourcesType[ExtraResourcesType["Teacher"] = 20] = "Teacher";
    ExtraResourcesType[ExtraResourcesType["Explanation"] = 30] = "Explanation";
    ExtraResourcesType[ExtraResourcesType["Extra"] = 40] = "Extra";
})(ExtraResourcesType || (ExtraResourcesType = {}));
const ExtraResourceString = {
    [20]: "교사용",
    [10]: "학생용",
    [40]: "부가자료",
    [30]: "해설지"
};
export const ExtraResourceNew = (param)=>/*#__PURE__*/ {
    let { type  } = param;
    return _jsx(ExtraResourcesWrapper, {
        className: "type".concat(type),
        children: ExtraResourceString[type]
    });
} //10:학생용, 20:선생용, 30:해설지, 40:부가자료
;
